export const getRawHtml = (_html: any) => {
  const html = String(_html).replace(/&nbsp;/g, '');

  const divElement = document.createElement('div');
  divElement.innerHTML = html;
  const elements = divElement.getElementsByTagName('*');

  for (const el of elements) {
    el.removeAttribute('style');
    el.removeAttribute('class');

    if (!el.innerHTML) {
      el.remove();
    }
  }

  // Find the figure element within the temporary element
  const figureElements = divElement.querySelectorAll('figure');

  for (const f of figureElements) {
    // If the figure element is found, replace it with its contents
    const parent = f.parentElement;

    if (parent?.innerHTML) {
      while (f.firstChild) {
        parent?.insertBefore(f.firstChild, f);
      }
      parent?.removeChild(f);
    }
  }

  return divElement.innerHTML;
};
